export const categoryRequest = ({
    name,
    description,
    active
} = {}) => ({
    name,
    description,
    active
})